// extracted by mini-css-extract-plugin
export default {"colorsList":"ColorPicker_colorsList__7kGy-","colorBox":"ColorPicker_colorBox__1tB0s","active":"ColorPicker_active__W2Rxb"};